define(["require", "exports", "./ServiceBase"], function (require, exports, ServiceBase_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MobileService = void 0;
    class MobileService extends ServiceBase_1.ServiceBase {
        constructor(httpProtocol, hostName, serviceName, proxyUrl) {
            super("Mobile", httpProtocol, hostName, serviceName, proxyUrl);
        }
        generateAggregatedMobileReport(reportParameters) {
            let p = {};
            p.reportParameters = reportParameters;
            return this.post("GenerateAggregatedMobileReport", p, (json) => {
                return json;
            });
        }
        generateAllDataAggregatedMobileReport(reportParameters) {
            let p = {};
            p.reportParameters = reportParameters;
            return this.post("GenerateAllDataAggregatedMobileReport", p, (json) => {
                return json;
            });
        }
        getAggregatedMobileReport(reportFileId) {
            let p = {};
            p.reportFileId = reportFileId;
            return this.requestFile("GetAggregatedMobileReport", p);
        }
        getAllDataAggregatedMobileReport(reportFileId) {
            let p = {};
            p.reportFileId = reportFileId;
            return this.requestFile("GetAllDataAggregatedMobileReport", p);
        }
        getMobileDocument(documentId) {
            let p = {};
            p.documentId = documentId;
            return this.requestFile("GetMobileDocument", p);
        }
        getAuthorisedLgas() {
            let p = {};
            return this.post("GetAuthorisedLgas", p, (json) => {
                return json;
            });
        }
        getAuthorisedLgasWithGeometry(returnPolyline, generalise) {
            let p = {};
            p.returnPolyline = returnPolyline;
            p.generalise = generalise;
            return this.post("GetAuthorisedLgasWithGeometry", p, (json) => {
                return json;
            });
        }
        getConfiguration() {
            let p = {};
            return this.post("GetConfiguration", p, (json) => {
                return json;
            });
        }
        getLgas() {
            let p = {};
            return this.post("GetLgas", p, (json) => {
                return json;
            });
        }
        getLotPlanQvasEvaluation(lotPlan) {
            let p = {};
            p.lotPlan = lotPlan;
            return this.post("GetLotPlanQvasEvaluation", p, (json) => {
                return json;
            });
        }
        getUser() {
            let p = {};
            return this.post("GetUser", p, (json) => {
                return json;
            });
        }
        keepAlive() {
            let p = {};
            return this.post("KeepAlive", p, (json) => {
                return json;
            });
        }
    }
    exports.MobileService = MobileService;
});
